<div class="bg-white rounded p-3 flex flex-col gap-1">
  <p class="subtitle-2 mb-1">
    {{ 'outlook.calendar.compose.notInMaximizer' | translate }} ({{
      attendees().length
    }})
  </p>

  <kendo-listview
    [data]="listViewData()"
    [pageable]="showPagerNavigation()"
    [pageSize]="pageSize"
    [skip]="clampedSkip()"
    (pageChange)="onPageChange($event)"
    class="border-none main-page"
  >
    <ng-template kendoListViewItemTemplate let-attendee="dataItem">
      <maximizer-outlook-calendar-attendee-item
        [attendee]="attendee"
        [userEmails]="userEmails()"
        [mode]="mode()"
        [popupContainer]="viewContainerRef"
        (navigate)="navigate.emit($event)"
        (addEntry)="addEntry.emit($event)"
        (notify)="notify.emit($event)"
      ></maximizer-outlook-calendar-attendee-item>
    </ng-template>
  </kendo-listview>
</div>
